export const commonSizes = [
  // Social Media
  {
    label: 'Infographic',
    width: 1080,
    height: 3688,
    autoHeight: true,
    value: 'infographic',
    category: 'social',
  },
  { label: 'Red Post', width: 1080, height: 1440, value: 'redNote', category: 'social' },
  { label: 'Instagram Post', width: 1080, height: 1080, value: 'instagram', category: 'social' },
  { label: 'Facebook Post', width: 1200, height: 630, value: 'facebook', category: 'social' },
  { label: 'Twitter Post', width: 1200, height: 675, value: 'twitter', category: 'social' },
  { label: 'LinkedIn Post', width: 1200, height: 1200, value: 'linkedin', category: 'social' },
  { label: 'LinkedIn ADs', width: 1200, height: 627, value: 'linkedin_ads', category: 'social' },
  { label: 'Pinterest Pin', width: 1000, height: 1500, value: 'pinterest', category: 'social' },
  { label: 'YouTube Thumbnail', width: 1280, height: 720, value: 'youtube', category: 'social' },
  { label: 'Wechat Post', width: 900, height: 383, value: 'wechatMpCover', category: 'social' },

  // device
  { label: 'Mobile Poster', width: 1080, height: 1920, value: 'mobilePoster', category: 'device' },
  { label: 'TV Screen', width: 1920, height: 1080, value: 'tvScreen', category: 'device' },

  // Print
  {
    label: 'Pull Up Banner | 80×200cm',
    width: 800,
    height: 2000,
    value: 'pullUpBanner',
    physicalDimensions: {
      unit: 'cm',
      width: 80,
      height: 20,
    },
    category: 'print',
  },
  {
    label: 'Flyer',
    width: 1080,
    height: 1527,
    value: 'flyer',
    physicalDimensions: {
      unit: 'cm',
      width: 21,
      height: 29.7,
    },
    category: 'print',
  },
  { label: 'A2 Paper', width: 1080, height: 1527, value: 'a2', category: 'print' },
  { label: 'A3 Paper', width: 1080, height: 1527, value: 'a3', category: 'print' },
  {
    label: 'A4 Paper',
    width: 1080,
    height: 1527,
    value: 'a4',
    physicalDimensions: {
      unit: 'cm',
      width: 21,
      height: 29.7,
    },
    category: 'print',
  },
  { label: 'A5 Paper', width: 1080, height: 1527, value: 'a5', category: 'print' },
  { label: 'A2 (Portrait)', width: 1527, height: 1080, value: 'a2h', category: 'print' },
  { label: 'A3 (Portrait)', width: 1527, height: 1080, value: 'a3h', category: 'print' },
  {
    label: 'A4 (Portrait)',
    width: 1527,
    height: 1080,
    value: 'a4h',
    physicalDimensions: {
      unit: 'cm',
      width: 29.7,
      height: 21,
    },
    category: 'print',
  },
  { label: 'A5 (Portrait)', width: 1527, height: 1080, value: 'a5h', category: 'print' },
  {
    label: 'Table Card | 10×15cm',
    width: 1080,
    height: 1620,
    value: 'tableCard10x15',
    category: 'print',
  },
  {
    label: 'Table Card | 15×20cm',
    width: 1080,
    height: 1440,
    value: 'tableCard15x20',
    category: 'print',
  },
  {
    label: 'Light Box Poster | 60×90cm',
    width: 600,
    height: 900,
    value: 'lightBoxPoster',
    category: 'print',
  },
  { label: 'Business Card', width: 1050, height: 600, value: 'businessCard', category: 'print' },
  { label: 'Postcard', width: 720, height: 1080, value: 'postcard', category: 'print' },
  { label: 'Flyer', width: 1080, height: 1400, value: 'flyer', category: 'print' },
  { label: 'Brochure', width: 1080, height: 700, value: 'brochure', category: 'print' },
  { label: 'Poster', width: 1080, height: 1528, value: 'poster', category: 'print' },
  { label: 'Banner', width: 1080, height: 540, value: 'banner', category: 'print' },
  { label: 'Billboard', width: 1080, height: 540, value: 'billboard', category: 'print' },
  { label: 'Menu', width: 1080, height: 1528, value: 'menu', category: 'print' },

  // Aspect Ratios
  { label: '1:1', width: 1080, height: 1080, value: 'square', category: 'aspect' },
  { label: '1:2', width: 540, height: 1080, value: 'tall', category: 'aspect' },
  { label: '2:1', width: 1080, height: 540, value: 'panoramic', category: 'aspect' },
  { label: '2:3', width: 720, height: 1080, value: 'classicPortrait', category: 'aspect' },
  { label: '3:2', width: 1080, height: 720, value: 'classic', category: 'aspect' },
  { label: '3:4', width: 1080, height: 1440, value: 'portrait', category: 'aspect' },
  { label: '4:3', width: 1440, height: 1080, value: 'landscape43', category: 'aspect' },
  { label: '4:5', width: 1080, height: 1350, value: 'tallClassic', category: 'aspect' },
  { label: '5:4', width: 1350, height: 1080, value: 'wideClassic', category: 'aspect' },
  { label: '9:16', width: 1080, height: 1920, value: 'portrait916', category: 'aspect' },
  { label: '16:9', width: 1280, height: 720, value: '16:9', category: 'aspect' },
  { label: '16:9', width: 1920, height: 1080, value: 'landscape', category: 'aspect' },
];
